import { ATTACHMENT_KIND } from './sheet-sections.js';
export const DESIGN_IMAGE_GROUPS = [
    { id: 'sketch', kind: ATTACHMENT_KIND.FLAT_SKETCH, label: 'sheet.flatSketch' },
    { id: 'detail', kind: ATTACHMENT_KIND.DETAIL_IMAGE, label: 'sheet.detailImages' },
    { id: 'fg', kind: ATTACHMENT_KIND.FG_IMAGE, label: 'sheet.fgImage' },
];
export const isDesignImage = (file) => DESIGN_IMAGE_GROUPS.some(group => group.kind === file.kind);
/** Categories organize the document without rewriting file purposes or storage identities. */
export function resolveDesignImageGroups(files, layout) {
    const saved = layout?.groups ?? [];
    const groups = DESIGN_IMAGE_GROUPS.map(group => ({
        id: group.id, name: saved.find(row => row.id === group.id)?.name ?? null,
        label: group.label, isDefault: true, files: [],
    }));
    for (const group of saved)
        if (!groups.some(row => row.id === group.id))
            groups.push({ ...group, label: '', isDefault: false, files: [] });
    const remaining = new Map(files.filter(isDesignImage).map(file => [file.id, file]));
    for (const placement of layout?.placements ?? []) {
        const file = remaining.get(placement.attachmentId), group = groups.find(row => row.id === placement.groupId);
        if (file && group) {
            group.files.push(file);
            remaining.delete(file.id);
        }
    }
    for (const file of remaining.values())
        groups.find(group => group.id === DESIGN_IMAGE_GROUPS.find(row => row.kind === file.kind).id).files.push(file);
    return groups;
}
export function normalizeDesignImageLayout(files, layout) {
    const groups = resolveDesignImageGroups(files, layout);
    return { ...(layout?.cover && files.some(file => file.id === layout.cover.attachmentId && isDesignImage(file)) ? { cover: layout.cover } : {}), groups: groups.map(({ id, name }) => ({ id, name: name?.trim() || null })),
        placements: groups.flatMap(group => group.files.map(file => ({ attachmentId: file.id, groupId: group.id }))) };
}
/** Move by persistent attachment ID; never use an array index as file identity. */
export function moveDesignImage(files, layout, attachmentId, groupId, beforeId) {
    const groups = resolveDesignImageGroups(files, layout), target = groups.find(group => group.id === groupId);
    const file = groups.flatMap(group => group.files).find(row => row.id === attachmentId);
    if (!target || !file || beforeId === attachmentId || (beforeId && !target.files.some(row => row.id === beforeId)))
        return normalizeDesignImageLayout(files, layout);
    for (const group of groups)
        group.files = group.files.filter(row => row.id !== attachmentId);
    const index = beforeId ? target.files.findIndex(row => row.id === beforeId) : target.files.length;
    target.files.splice(index, 0, file);
    return { groups: groups.map(({ id, name }) => ({ id, name })), placements: groups.flatMap(group => group.files.map(row => ({ attachmentId: row.id, groupId: group.id }))) };
}
//# sourceMappingURL=design-images.js.map